module.exports = __webpack_public_path__ + "img/Lasagna_Meal_Spinach_Feta.175a9e01.jpg";